<div
    [class]="{
        'loader-container': true,
        'content-loader': contentLoader,
        'guest-loader': guestLoader,
    }"
>
    <nz-icon nzType="loading" nzTheme="outline"></nz-icon>
</div>
